<template lang="pug">
  router-view
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/components/PublicPage.vue